import { create } from 'jss';
import React from 'react';
import { BinProfileIngredient } from '~/bins/bin-level/bin-profile-ingredient';
import { muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';
import { ThemeProviderV4, StyledEngineProvider, StylesProviderV4, jssPreset, ThemeProvider } from '~/lib/bn-material-ui';

export function binProfileIngredientParcel (props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider jss={jss} generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 jss={jss} generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            <BinProfileIngredient {...props} />
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}
